"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
/**
 * Preload the image with a provided img src or optional fallback if src fails
 * 
 * @param {string} src - default img src
 * @param {string} fallback - fallback img to use if src fails 
 * @param {boolean} preload - fallback img to use if src fails 
 * @returns {object} Image load boolean states {isLoaded, isFallbackLoaded, didImageSrcError} 
 */


var usePreloadImage = function usePreloadImage(_ref) {
  var src = _ref.src,
      fallback = _ref.fallback,
      preload = _ref.preload;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoaded = _useState2[0],
      setIsLoaded = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isFallbackLoaded = _useState4[0],
      setIsFallbackLoaded = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      didImageSrcError = _useState6[0],
      setDidImageSrcError = _useState6[1];

  var successLoad = function successLoad() {
    setIsLoaded(true);
  };

  var successFallbackLoad = function successFallbackLoad() {
    setIsFallbackLoaded(true);
  };

  var usefallback = function usefallback() {
    setDidImageSrcError(true);
    var preloaderFallback = document.createElement("img");
    if (fallback) preloaderFallback.src = fallback;
    preloaderFallback.addEventListener("load", successFallbackLoad, {
      once: true
    });
  };

  (0, _react.useEffect)(function () {
    if (!isLoaded && preload) {
      var preloaderImg = document.createElement("img");
      preloaderImg.src = src;
      preloaderImg.addEventListener("load", successLoad, {
        once: true
      });
      if (fallback) preloaderImg.addEventListener("error", usefallback, {
        once: true
      });
    }
  }, [preload]);
  return {
    isLoaded: isLoaded,
    isFallbackLoaded: isFallbackLoaded,
    didImageSrcError: didImageSrcError
  };
};

var _default = usePreloadImage;
exports["default"] = _default;